import Link from 'next/link';
import { Icon } from '@/components/ui/icon';

const GlossaryInlineCta = ({ title, description, buttonLabel, buttonLink, icon = 'profile2Users' }) => {
  if (!title && !buttonLabel) return null;

  return (
    <aside className="bg-brand-50 border-brand-200 my-4 flex flex-col items-start gap-6 rounded-2xl border px-7 py-7 xl:flex-row xl:items-center">
      <div className="bg-brand-500 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white">
        <Icon type={icon} width={24} height={24} />
      </div>
      <div className="flex-1">
        {title && <h3 className="mb-1 text-lg">{title}</h3>}
        {description && <p className="text-grey-700 text-sm leading-relaxed">{description}</p>}
      </div>
      {buttonLabel && buttonLink && (
        <Link
          href={buttonLink}
          className="bg-brand-500 hover:bg-brand-600 shrink-0 rounded-full px-7 py-3.5 text-sm font-medium text-white transition-colors"
        >
          {buttonLabel}
        </Link>
      )}
    </aside>
  );
};

export default GlossaryInlineCta;
